import { render } from "./DetailComponent.vue?vue&type=template&id=2fe2c3e0&scoped=true"
import script from "./DetailComponent.vue?vue&type=script&lang=js"
export * from "./DetailComponent.vue?vue&type=script&lang=js"

import "./DetailComponent.vue?vue&type=style&index=0&id=2fe2c3e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe2c3e0"]])

export default __exports__